import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./styles.module.scss";
import { FC, ITemplateGroup, Props } from "./typings";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { useOnClickOutside } from "usehooks-ts";
import externalService from "api/externalService";
import editorService from "api/editorService";
import Input from "components/Input";
import tagsService from "api/tagsService";
import classNames from "classnames";

const SelectTemplate: FC<Props> = ({
  isExternal = false,
  onChoose,
}) => {
  const [groupedTemplates, setGroupedTemplates] = useState<ITemplateGroup[]>(
    []
  );
  const [active, setActive] = useState(false);

  const [value, setValue] = useState("");

  const { data: externalTemplates } = externalService.useGetTemplate(value);

  const { data: templates } = editorService.useGetTemplate(value, false, true);
  const { data: tagsData } = tagsService.useGetTags();

  const outsideRef = useRef(null);

  useOnClickOutside(outsideRef, () => {
    if (active) {
      setActive(false);
    }
  });

  useEffect(() => {
    if (tagsData?.data && templates?.data) {
      const uniqueTags = templates.data.Items.filter((x) => x.TagIds !== null)
        .map((x) => x.TagIds)
        .flat()
        .filter((value, index, array) => array.indexOf(value) === index);

      const groups: ITemplateGroup[] = [];

      uniqueTags.forEach((t) => {
        const tag = tagsData.data.find((x) => x.Id === t);

        if (tag != null) {
          groups.push({
            Id: tag.Id,
            Name: tag.Name,
            IsExpanded: false,
            Templates: templates.data.Items.filter(
              (x) => x.TagIds != null && x.TagIds.indexOf(tag.Id) !== -1
            ),
          });
        }
      });

      const withoutGroup = templates.data.Items.filter(
        (x) => x.TagIds === null || x.TagIds.length === 0
      );

      if (withoutGroup.length > 0) {
        groups.push({
          Id: "other",
          Name: "Inne",
          IsExpanded: false,
          Templates: withoutGroup,
        });
      }

      setGroupedTemplates(groups);
    }
  }, [tagsData, templates]);

  const toggle = (itm: ITemplateGroup) => {
    const newCollection = [...groupedTemplates];
    const toUpdate = newCollection.find((x) => x.Id == itm.Id);

    if (toUpdate) {
      toUpdate.IsExpanded = !toUpdate.IsExpanded;
    }

    setGroupedTemplates(newCollection);
  };

  return (
    <div ref={outsideRef} className={styles.wrapper}>
      <div onClick={() => setActive(!active)} className={styles.card}>
        <Input
          label="Szablon"
          placeholder="Szablon"
          onChange={(t) => setValue(t)}
          value={value}
        />
      </div>

      {active && (
        <div className={styles.dropdown}>
          <div className={styles.list}>
            {isExternal &&
              externalTemplates?.map((ex) => {
                return (
                  <div
                    onClick={() => {
                      setActive(false);
                      onChoose(ex);
                    }}
                    key={ex.Id}
                    className={styles.box}
                  >
                    {ex.S1}
                  </div>
                );
              })}
            {!isExternal &&
              groupedTemplates?.map((ex) => {
                return (
                  <div className={styles.item} key={ex.Id}>
                    <div className={styles.group} onClick={() => toggle(ex)}>
                      {ex.Name}{" "}
                      <div className={styles.expanderWrapper}>
                        <FontAwesomeIcon
                          className={classNames(styles.expander)}
                          icon={ex.IsExpanded ? faCaretDown : faCaretUp}
                        />
                      </div>
                    </div>
                    {ex.IsExpanded &&
                      ex.Templates.map((ex2) => {
                        return (
                          <div
                            onClick={() => {
                              setActive(false);
                              onChoose(ex2);
                              setValue(ex2.Label ?? ex2.FileName);
                            }}
                            key={ex2.Id}
                            className={styles.box}
                          >
                            {ex2.Label ?? ex2.FileName}
                          </div>
                        );
                      })}
                  </div>
                );
              })}
            {/* {statuses?.map((status) => (
              <div
                onClick={() => {
                  setActive(false);
                  onChoose(status);
                }}
                key={status.Id}
                className={styles.box}
              >
                {status.Name}
              </div>
            ))} */}
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectTemplate;
